import { Entity } from "../../common/types/entity";

export function getEntityPaneKey(key: string, entity: Entity) {
    return `${key}-${entity.id}` as const;
}

export type EntityPaneKey = ReturnType<typeof getEntityPaneKey>;
